
class SetError {
};

class ValueError {
	constructor(value) {
		this.value = value
	}
}

const setSettings = (json, dest) => {
	if (typeof json === 'object') {
		Object.entries(json).forEach(([key, value]) => {
			try {
				setSettings(value, dest[key])
			} catch (e) {
				if (e instanceof TypeError) {
					throw new ValueError(`${key}/${e}`)
				} else if (e instanceof SetError) {
					throw new ValueError(`${key}/${e}`)
				} else {
					throw e
				}
			}
		})
	} else {
		try {
			dest.setValue(json)
		} catch (e) {
			if (e instanceof TypeError) {
				throw new SetError()
			} else {
				throw e
			}
		}
	}
}

export { setSettings, ValueError }
